import type { Locale } from '@app/api'

export const localeOptions = ['de', 'ru'] as const satisfies readonly Locale[]
